
import { Component, OnInit } from '@angular/core';
import { Modal} from '@dds-uicore/all'
import { DataService } from '../data.service';
import { PartAttachmentInfo } from '../model/part-attachment-info';
import { URLParams } from '../model/urlparams';
import { UserPrivilegeInfo } from '../model/user-privilege-info';
import { AgileSDKService } from '../services/agile-sdk.service';
import { ViewportScroller } from '@angular/common';
import { AgileFileUploadRequest } from '../model/agile-file-upload-request';
import { AgileFileDownloadRequest, DownloadFilesInfo } from '../model/agile-file-download-request';
import { Router } from '@angular/router';
import { DownloadStatusModel } from '../model/download-status-model';
import { FileCatalystAPIService } from '../services/file-catalyst-api.service';
import { AgileFileDeleteRequest, DeleteFileInfo } from '../model/agile-file-delete-request';
import { FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { FileExplorerOut } from '../model/file-explorer-out';
import { FileElement } from '../model/file-element';
import { AgileFileInfo } from '../model/agile-file-info';
import { UploadStatusModel } from '../model/upload-status-model';
import { FileTypeCodeInfo } from '../model/file-type-code-info.model';
import { Subscription, interval } from 'rxjs';



@Component({
  selector: 'app-part-attachment',
  templateUrl: './part-attachment.component.html',
  styleUrls: ['./part-attachment.component.css']
})
export class PartAttachmentComponent implements OnInit {
  // data_test: { filename: string; fileDesc: string; fileSize: string; fileType: string; folderNumber: string; folderVersion: string; fileTypeCode: string; fileDestination: string; }[];
  checkAll:boolean = false;
  checkMain:boolean = false;
  replaceSectionVisible : boolean = false
  accToggleValue : boolean
  isLoading : boolean = true;
  errorLoading : boolean = false;
  errorLoadingMsg : string = '';

  bodyText: string;
  userPrivilegeInfo: UserPrivilegeInfo;
  hasDownloadPrivilege :boolean
  hasReplacePrivilege : boolean
  hasDeletePrivilege : boolean
  dataEmpty : boolean = false;
  rowSelected: boolean = false;

  nProgressStatus:string = 'inprogress';
  completeStatus:string = 'complete';
  failedStatus:string = 'failed';
  notStartedStatus:string = 'notstarted';

  attachmentInfoDynamicForm:FormGroup;
  selectedFiles:FileElement[] = [];
  selectedFilesString:string[] = [];
  uploadFileInfo:AgileFileInfo[] = [];
  allowedFileExtensionsString:string = '';
  fileExtensionRowErr: string[]=[];
  uploadFilesError: boolean = false;
  
  hasUploadPrivilege:boolean = false;
  
  constructor(private agileService:AgileSDKService,private dataService:DataService,public viewportScroller : ViewportScroller,
    private router:Router,private fcService:FileCatalystAPIService,private formBuilder: FormBuilder) {
    this.attachmentInfoDynamicForm = this.formBuilder.group({
      attachments:new FormArray([])
    });

   }

  urlParams:URLParams;
  partAttachments:PartAttachmentInfo[];
  selectedPartAttachments:PartAttachmentInfo[];

  loadingModalMessage:string;

  ngOnInit(): void {
    // this.getData1()
    //   .then((data) => this.createOptions1(data))
    //   .then((options) => { 

    //     // then and initilize DDS Table element 
    //     const tableElement = document.querySelectorAll("[data-table=\"dds__table1\"]");
    //     new Table(tableElement[0], options);
    //   });
     
      // this.getData2()
      // .then((data) => this.createOptions2(data))
      // .then((options) => { 

      //   // then and initilize DDS Table element 
      //   const tableElement = document.querySelectorAll("[data-table=\"dds__table2\"]");
      //   new Table(tableElement[0], options);
      // });
      this.accToggleValue = this.dataService.toggleValue
    this.urlParams = this.dataService.getUrlParams();
    this.userPrivilegeInfo = this.dataService.getUserPrivilegeInfo()
    this.hasDownloadPrivilege = this.userPrivilegeInfo.hasDownloadPrivilege
    this.hasReplacePrivilege = this.userPrivilegeInfo.hasReplacePrivilege
    this.hasDeletePrivilege = this.userPrivilegeInfo.hasDeletePrivilege
    this.hasUploadPrivilege = this.dataService.userPrivilegeInfo.hasUploadPrivilege;
    //  this.loadStaticData();
    this.getPartAttachmentInfo();
   

    const modal = document.querySelectorAll('[data-toggle=\"dds__modal\"]');
     new Modal(modal[0],{backdrop :'static'});
   
    
  }

  getPartAttachmentInfo()
  {
    

    console.log('URL Params ',this.urlParams)
    if(this.urlParams != undefined)
    {

      console.log('Part Num ',this.urlParams.partNumber,':::: Part Rev ',this.urlParams.partRevision)

      
      this.agileService.getItemAttachments(this.urlParams.partNumber,this.urlParams.partRevision).subscribe(
        (data) =>
        {
          
          console.log('Part Attachments ',data)
          if(data.processComplete){
            
            this.partAttachments = data.partAttachments;
            this.dataService.setPartAttachments(this.partAttachments);
            if(data.uploadMsg){
              this.dataService.setUploadPGPMessage(data.uploadMsg);
            }

            if(data.downloadMsg){
              this.dataService.setDownloadPGPMessage(data.downloadMsg);
            }
            console.log('setting the flag to false')
            this.isLoading = false;
            if(this.partAttachments != undefined && this.partAttachments.length == 0){
              console.log('empty')
              this.dataEmpty = true
            }
          }else{
            this.isLoading = false;
            this.errorLoading = true
            this.errorLoadingMsg = data.errorMessage;
          }
        
        },
        (error)=>{
          console.log('error ',error)
          this.isLoading = false
          this.errorLoading = true
          this.errorLoadingMsg = 'Something went wrong, please try again...'
        }

        
        )


    }
    
  }
  
 

  onCheckAll()
  {

    
    this.t.clear();
    this.checkAll = !this.checkAll;
    this.checkAll = this.checkMain = !this.checkMain;
    console.log('In check all method ',this.checkAll+', check main ',this.checkMain)
    if(this.checkAll)
    {
      
      this.partAttachments.forEach((attachment)=>{
        attachment.fileSelected = true;
      })
      this.rowSelected = true
    }else
    {
      this.partAttachments.forEach((attachment)=>{
        attachment.fileSelected = false;
      })
      this.rowSelected = false
    }

    this.partAttachments.forEach((partAttachment) => {

      let disableDigitalSign:boolean = true;
     
      // console.log('Iterating thru part attachments ',partAttachment.fileSelected)
      if(partAttachment.fileSelected){
        let localFileTypeRes = [];
        localFileTypeRes = this.dataService.getDigitalSign(partAttachment.fileTypeCode);
        if (localFileTypeRes[0].digitalSign == 1) {
              console.log("Digital Sign 1");
              // this.t.at(index).get('digitalSign').enable();
              disableDigitalSign=false;
            }
        // omitting zip pack files from replace list
        if(!(partAttachment.fileTypeCode == 'ZP:A self-extracting ZIP with a user-friendly front-end.' || 
        partAttachment.fileTypeCode == 'ZPE:ZipPack External' || partAttachment.fileTypeCode == 'ZPH: Zippack Header File Information')){

          let aRevFileTypeCodes:string[] = this.dataService.getArevFileTypeCodes();
          if(this.dataService.urlParams.partRevision.startsWith("A")){

            

            if(aRevFileTypeCodes.includes(partAttachment.fileTypeCode)){
              this.t.push(this.formBuilder.group({
                fileName:partAttachment.fileName,
                fileTypeCode:partAttachment.fileTypeCode,
                digitalSign:{value:false,disabled:disableDigitalSign},
                fileNameWithPath:[''],
                fileSource:['']
                }));
            }
            
          }else{
            this.t.push(this.formBuilder.group({
              fileName:partAttachment.fileName,
              fileTypeCode:partAttachment.fileTypeCode,
              digitalSign:{value:false,disabled:disableDigitalSign},
              fileNameWithPath:[''],
              fileSource:['']
              }));
          }

          
        }
      }
      console.log('this.t.controls.length ',this.t.controls.length)
      if(this.t.controls.length == 0){
        console.log('Replace section to false')
        this.replaceSectionVisible = false;
      }
    })
  }

  onCheckboxChange(partAttachment:PartAttachmentInfo)
  {

    console.log('Clearing the values')
    this.t.clear();
    console.log('Cleared the values')
    if(partAttachment != undefined){
      partAttachment.fileSelected = !partAttachment.fileSelected;
      if(!partAttachment.fileSelected && this.checkAll){
        // this.checkAll = !this.checkAll;
        this.checkMain = !this.checkMain;
      }
      // here
      if(this.partAttachments.filter((value) => value.fileSelected == true).length > 0)
      {
        this.rowSelected = true
      }else{
        this.rowSelected = false
        
      }
      
      
      this.partAttachments.forEach((partAttachment) => {

        let disableDigitalSign:boolean = true;
        
        console.log('Iterating thru part attachments ',partAttachment.fileSelected)
        // pushing to form array for replace functionality
        if(partAttachment.fileSelected && partAttachment.fileTypeCode !=undefined && partAttachment.fileTypeCode != ''){
          let localFileTypeRes = this.dataService.getDigitalSign(partAttachment.fileTypeCode);
        if (localFileTypeRes[0].digitalSign == 1) {
              console.log("Digital Sign 1");
              // this.t.at(index).get('digitalSign').enable();
              disableDigitalSign=false;
            }
          // omitting zip pack files from replace list
          if(!(partAttachment.fileTypeCode == 'ZP:A self-extracting ZIP with a user-friendly front-end.' || 
          partAttachment.fileTypeCode == 'ZPE:ZipPack External' || partAttachment.fileTypeCode == 'ZPH: Zippack Header File Information')){

            let aRevFileTypeCodes:string[] = this.dataService.getArevFileTypeCodes();
            if(this.dataService.urlParams.partRevision.startsWith("A")){
              if(aRevFileTypeCodes.includes(partAttachment.fileTypeCode)){
                this.t.push(this.formBuilder.group({
                  fileName:partAttachment.fileName,
                  fileTypeCode:partAttachment.fileTypeCode,
                  digitalSign:{value:false,disabled:disableDigitalSign},
                  fileNameWithPath:[''],
                  fileSource:['']
                  }));
              }
              
            }else{
              this.t.push(this.formBuilder.group({
                fileName:partAttachment.fileName,
                fileTypeCode:partAttachment.fileTypeCode,
                digitalSign:{value:false,disabled:disableDigitalSign},
                fileNameWithPath:[''],
                fileSource:['']
                }));
            }

            
          }
          
        }

        
      })
      console.log('this.t.controls.length ',this.t.controls.length)
      if(this.t.controls.length == 0){
        console.log('Replace section to false')
        this.replaceSectionVisible = false;
      }
    }
  }
 
  onDownload(){
    console.log('On Download, Part Attachment Info ',this.partAttachments);
    let selectedFileNames="";

    this.selectedPartAttachments = this.partAttachments.filter((value) => {if(value.fileSelected)
      {
        selectedFileNames+=","+value.fileName
        return value;
      }})
      console.log('selected ',this.selectedPartAttachments)
      let result = window.confirm('Do you want to proceed to Download '+selectedFileNames.substring(1));
      if(result){

      if(this.selectedPartAttachments.length > 0){
        let downloadFiles:DownloadStatusModel[] = [];
        console.log('Call the Agile Download service ');
        let agileFileDownloadReq:AgileFileDownloadRequest;
        let downloadFilesInfo:DownloadFilesInfo[] = [];
       



        this.loadingModalMessage = "Initiating Download process..."
        if(this.accToggleValue===false){

          //********************************************************************
          //*********************  Non-Accelerated Transfer    *****************
          //********************************************************************

          this.dataService.setAgileFileDownloadRequests(agileFileDownloadReq);
         

          this.selectedPartAttachments.forEach((selectedAttachment) => 
          {
            downloadFilesInfo.push(
              {
               
                fileName:selectedAttachment.fileName,
                folderNumber:selectedAttachment.folderNumber,
                folderVersion:selectedAttachment.folderVersion
              }
            )

            let downloadFile:DownloadStatusModel;
            downloadFile = {
              fileName:selectedAttachment.fileName,
              agileDownloadStatus:this.notStartedStatus,
              acceleratedTransfer:false,
              fcDownloadStatus:this.notStartedStatus,
              statusPanelEnabled:false,
              agileDownloadMessage:'Not started',
              fileDownloadMessage:{
                Transfer_Rate:'NA',
                Current_Percent:'NA',
                Transfer_Mode:'NA',
                Time_Remaining:'NA',
                Download_Location:'NA'
              }
            };
            this.dataService.addToDownloadFiles(downloadFile);
            // downloadFiles.push(
            //   {
            //   fileName:selectedAttachment.fileName,
            //   agileDownloadStatus:this.notStartedStatus,
            //   acceleratedTransfer:false,
            //   fcDownloadStatus:this.notStartedStatus,
            //   statusPanelEnabled:false,
            //   agileDownloadMessage:'Not started',
            //   fileDownloadMessage:{
            //     Transfer_Rate:'NA',
            //     Current_Percent:'NA',
            //     Transfer_Mode:'NA',
            //     Time_Remaining:'NA',
            //     Download_Location:'NA'
            //   }
            // }
            // )
          })
  
          agileFileDownloadReq = {
            partNumber:this.dataService.getUrlParams().partNumber,
            partRev:this.dataService.getUrlParams().partRevision,
            downloadFilesInfo:downloadFilesInfo,
            acceleratedTransfer:false,
            transferComplete:false
          }
          console.log('selected Agile Download Req Info ',agileFileDownloadReq)
          // this.dataService.setDownloadFilesInfo(downloadFiles);
          this.router.navigate(['transferstatus_v2'],{skipLocationChange:true})
          // this.getDownloadZipFileResponse(agileFileDownloadReq);
        }
        else{

            //***************************************************************************
          //*********************  Accelerated Transfer - File Catalyst *****************
          //*****************************************************************************

          this.selectedPartAttachments.forEach((selectedAttachment) => 
          {
            downloadFilesInfo.push(
              {
               
                fileName:selectedAttachment.fileName,
                folderNumber:selectedAttachment.folderNumber,
                folderVersion:selectedAttachment.folderVersion
              }
            )
            let downloadFile:DownloadStatusModel;
            downloadFile = {
              fileName:selectedAttachment.fileName,
              agileDownloadStatus:this.notStartedStatus,
              acceleratedTransfer:true,
              fcDownloadStatus:this.notStartedStatus,
              statusPanelEnabled:false,
              agileDownloadMessage:'Not started',
              fileDownloadMessage:{
                Transfer_Rate:'NA',
                Current_Percent:'NA',
                Transfer_Mode:'NA',
                Time_Remaining:'NA',
                Download_Location:'NA'
              }
            }
            this.dataService.addToDownloadFiles(downloadFile);
          })
  
          agileFileDownloadReq = {
            partNumber:this.dataService.getUrlParams().partNumber,
            partRev:this.dataService.getUrlParams().partRevision,
            downloadFilesInfo:downloadFilesInfo,
            acceleratedTransfer:true,
            transferComplete:false
          }
          console.log('selected Agile Download Req Info ',agileFileDownloadReq)
        this.dataService.setAgileFileDownloadRequests(agileFileDownloadReq);
        this.dataService.setDownloadFilesInfo(downloadFiles)
        // let result = window.confirm('please make sure that Transfer Agent is started');
        // if(result){
        //   console.log('entered after checking TA status')
          this.router.navigate(['transferstatus_v2'],{skipLocationChange:true})
        // }
        
        

        
        
        }

        this.dataService.setAgileFileDownloadRequests(agileFileDownloadReq);

      }
    }
  }

  onDelete(){
    let selectedFileNames=""
    console.log('On Delete, Part Attachment Info ',this.partAttachments)
    this.selectedPartAttachments = this.partAttachments.filter((value) => {if(value.fileSelected)
      {
        selectedFileNames+=","+value.fileName
        return value;
      }})
      let result = window.confirm('Do you want to proceed to Delete '+selectedFileNames.substring(1));
      if(result){

      let zpFileSelected:boolean = this.selectedPartAttachments.filter((value)=>{if(value.fileTypeCode == 'ZP:A self-extracting ZIP with a user-friendly front-end.'){return value;}}).length > 0;
      let selectedZpeExtFile:boolean = this.selectedPartAttachments.filter((value)=>{if(value.fileTypeCode == 'ZPE:ZipPack External'){return value;}}).length > 0;
      let selectedZpHeaderFile:boolean = this.selectedPartAttachments.filter((value)=>{if(value.fileTypeCode == 'ZPH: Zippack Header File Information'){return value;}}).length > 0;
      
      if(zpFileSelected){
        if(!selectedZpHeaderFile){
          this.partAttachments.forEach((value) => {
            if(value.fileTypeCode == 'ZPH: Zippack Header File Information'){
              value.fileSelected = true;
              this.selectedPartAttachments.push(value);
            }
          })
        }
        if(!selectedZpeExtFile){
          this.partAttachments.forEach((value) => {
            if(value.fileTypeCode == 'ZPE:ZipPack External'){
              value.fileSelected = true;
              this.selectedPartAttachments.push(value);
            }
          })
        }
      }else if(selectedZpeExtFile || selectedZpHeaderFile){
        console.log('selected either ZPE or ZPH without ZP')
        if(selectedZpeExtFile){
          this.selectedPartAttachments.forEach((value,index) => {
            if(value.fileTypeCode == 'ZPE:ZipPack External'){
              this.selectedPartAttachments.splice(index,1)
            }
          })
        }if(selectedZpHeaderFile){
          this.selectedPartAttachments.forEach((value,index) => {
            if(value.fileTypeCode == 'ZPH: Zippack Header File Information'){
              this.selectedPartAttachments.splice(index,1)
            }
          })
        }
        console.log('Cannot select ZPE:ZipPack External or ZPH: Zippack Header File Information without ZP:A self-extracting ZIP with a user-friendly front-end. file')
        window.alert('Cannot select ZPE:ZipPack External or ZPH: Zippack Header File Information without ZP:A self-extracting ZIP with a user-friendly front-end. file')
      }

      // if(this.selectedPartAttachments.filter((value)=>{if(value.fileTypeCode == 'ZP:A self-extracting ZIP with a user-friendly front-end.'){return value;}}).length > 0){
      //   let selectedZpeExtFile:boolean = this.selectedPartAttachments.filter((value)=>{if(value.fileTypeCode == 'ZPE:ZipPack External'){return value;}}).length > 0;
      //   let selectedZpHeaderFile:boolean = this.selectedPartAttachments.filter((value)=>{if(value.fileTypeCode == 'ZPH: Zippack Header File Information'){return value;}}).length > 0;
        
      //   if(!selectedZpeExtFile && !selectedZpHeaderFile ){
      //     this.partAttachments.forEach((value) => {
      //       if(value.fileTypeCode == 'ZPH: Zippack Header File Information' || value.fileTypeCode == 'ZPE:ZipPack External'){
      //         if(!selectedZpeExtFile && !selectedZpHeaderFile){
      //           console.log('Adding external and header file to the delete list ')
      //           this.selectedPartAttachments.push(value);
      //         }else if(!selectedZpeExtFile && value.fileTypeCode == 'ZPE:ZipPack External'){
      //           console.log('Adding external file to the delete list')
      //           this.selectedPartAttachments.push(value);
      //         }else if(!selectedZpHeaderFile && value.fileTypeCode == 'ZPH: Zippack Header File Information'){
      //           console.log('Adding header file to the delete list')
      //           this.selectedPartAttachments.push(value);
      //         }
              
      //       }
      //     })
      //   }

      // }
      console.log('selected ',this.selectedPartAttachments)
      if(this.selectedPartAttachments.length > 0){
        console.log('Call the Agile Delete service ');
        let agileFileDeleteReq:AgileFileDeleteRequest;
        // fileName:string;
        // fileTypeCode:string;
        // folderNumber:string;
        // folderVersion:string;
        // deleted:boolean;
        // deleteMessage:string;
        let deleteFilesInfo:DeleteFileInfo[] = [];
        this.selectedPartAttachments.forEach((selectedAttachment) => 
        {
          
          deleteFilesInfo.push(
            {
             
              fileName:selectedAttachment.fileName,
              folderNumber:selectedAttachment.folderNumber,
              folderVersion:selectedAttachment.folderVersion,
              fileTypeCode:selectedAttachment.fileTypeCode,
              deleted:false,
              deleteMessage:""
            }
          )
         
        })

        agileFileDeleteReq = {
          userName:this.dataService.getUrlParams().userName,
          partNumber:this.dataService.getUrlParams().partNumber,
          partRev:this.dataService.getUrlParams().partRevision,
          filesToDelete:deleteFilesInfo
        }
        console.log('selected Agile Delete Req Info ',agileFileDeleteReq)


        this.loadingModalMessage = "Initiating Delete process..."
        this.openProgressBar();
        this.agileService.deleteFileFromSWB(agileFileDeleteReq).subscribe(
          (deleteResp) => {
            // this.loadingModalMessage = "Downloaded File to Cache..."
            let successList:string[] = [];
            let failureList:string[] = [];
            console.log('Delete Response ',deleteResp)
            if(deleteResp.processCompleted){
              
              
              if(deleteResp.filesToDelete != undefined)
              { 
                deleteResp.filesToDelete.forEach((deletedFile) =>{
                 
                 console.log('deleted flag ',deletedFile.deleted) 
                 console.log('Download File ',deletedFile)

                  if(deletedFile.deleted)
                  {
                   //successfully Deleted Files Message
                   successList.push(deletedFile.fileName);
                  }else{
                  failureList.push("File Name: "+deletedFile.fileName+"; Error: "+deletedFile.deleteMessage)
                  }
                  
                })

                let message:string = "";
                if(successList != undefined && successList.length > 0){
                  message = message+"\n"+"Successfully deleted files :"+successList.toString()
                }
                if(failureList != undefined && failureList.length > 0){
                  message = message+"\n"+"Error in deleting the files: "+failureList.toString()
                }

                console.log('Message ',message);
                this.loadingModalMessage = message;

                setTimeout(() => {this.closeProgresBar()
                this.getPartAttachmentInfo()},5000);
              }

              

            }else
            {
              console.log('error while downloading the file ',deleteResp.errorMessage)
              this.loadingModalMessage = "Error while initiating Delete Process:",deleteResp.errorMessage, "please try again.."
              setTimeout(() => {this.closeProgresBar()},5000);
            }

          },
          (error) => {
            console.log('error while downloading the file ',error)
            this.loadingModalMessage = "Error while initiating Delete process, please try again.."
            setTimeout(() => {this.closeProgresBar()},5000);
            
          }
          
          )
        }
      }
  }

  enterFileName(fileExplorerOut : FileExplorerOut) : void{
    // console.log(fileNamePath)
    // this.fileNameTest = fileNamePath
    console.log('enterFile Name method ',fileExplorerOut.fileElement)
    // let fileNamePathSplit = fileNamePath.split("::");
    this.t.at(fileExplorerOut.index).patchValue({fileNameWithPath:fileExplorerOut.fileElement.name})

    this.selectedFiles.push(fileExplorerOut.fileElement);
    console.log('Value at 0 ',this.selectedFilesString[0]);
    console.log('Value at index ',this.selectedFilesString[fileExplorerOut.index]);
    this.selectedFilesString[fileExplorerOut.index] = fileExplorerOut.fileElement.path;
    console.log('Here 1')
    // if(this.selectedFilesString.indexOf(fileExplorerOut.fileElement.path) < 0){
      
      
    //   this.selectedFilesString.push(fileExplorerOut.fileElement.path);

    // }
    

    // this.f.get('fileNameWithPath').setValue(fileNamePath)
    // this.f['fileNameWithPath'].setValue(fileNamePath);
}
  



  getFileExtensionPartAtt(fileTypeCode: string): any[]{
    if(fileTypeCode!=""){
    console.log("Current File Type Code ",fileTypeCode);
    let localFileTypeRes=[];
    localFileTypeRes=this.dataService.getDigitalSign(fileTypeCode);
    
    return localFileTypeRes[0].extension;
    }
  }

  getFileExtensionStringPartAtt(fileTypeCode: string): any[]{
    if(fileTypeCode!=""){
    console.log("Current File Type Code ",fileTypeCode);
    let localFileTypeRes=[];
    localFileTypeRes=this.dataService.getDigitalSign(fileTypeCode);
    
    return localFileTypeRes[0].extension.toString();
    }
  }
  
  


  get f() { return this.attachmentInfoDynamicForm.controls; }
  get t() { return this.f.attachments as FormArray; }


  onReplace(){
    console.log('On Replace, Part Attachment Info ',this.partAttachments)
    this.replaceSectionVisible = !this.replaceSectionVisible;

    if(this.replaceSectionVisible){
      let aRevFileTypeCodes:string[] = this.dataService.getArevFileTypeCodes();
      console.log('A rev fileType codes ',aRevFileTypeCodes)
      let showMessage = false;
      let removedFiles:string[] = [];
      let message:string = '';
      this.selectedPartAttachments = this.partAttachments.filter((value) => {
        if(value.fileSelected)
        {
          if(this.dataService.urlParams.partRevision.startsWith("A")){
            if(aRevFileTypeCodes.includes(value.fileTypeCode)){
              return value;
            }else{
              showMessage = true;
              removedFiles.push(value.fileName)
              message = 'Files :'+removedFiles+', is(are) not allowed to replace on A-Rev';
              
            }
            
          }else if(value.fileTypeCode == 'ZP:A self-extracting ZIP with a user-friendly front-end.' || value.fileTypeCode == 'ZPE:ZipPack External'
          || value.fileTypeCode == 'ZPH: Zippack Header File Information'){

          
            removedFiles.push(value.fileName)
            showMessage = true;
            message = 'ZP:A self-extracting ZIP with a user-friendly front-end. or ZPE:ZipPack External or ZPH: Zippack Header File Information cannot be replaced, please delete the files and upload again'
          }
          
        }})
        
        if(showMessage && removedFiles.length > 0){
          window.alert(message)
        }
    }
    
      console.log('selected ',this.selectedPartAttachments)

    
      // this.selectedPartAttachments.forEach((selectedAttachment) => {
      //   console.log('selected part attachment ',selectedAttachment)
      //   console.log('selected part attachment filename ',selectedAttachment.fileName)
      //   console.log('selected part attachment filetypecode ',selectedAttachment.fileTypeCode)
      //   this.t.push(this.formBuilder.group({
      //     fileName:selectedAttachment.fileName,
      //     fileTypeCode:selectedAttachment.fileTypeCode
            
      //     }));
      
      // })
      // this.t.push(this.formBuilder.group({
      //   fileName:'Test FileName',
      //   fileTypeCode:"Test File Type Code"
          
      //   }));
      //   this.t.push(this.formBuilder.group({
      //     fileName:'Test FileName2',
      //     fileTypeCode:"Test File Type Code2"
            
      //     }));
     
     
  }

  onFileChange(event,i:number){
    if(event.target.files.length>0){
      console.log('index in onFile Change event ',i)
      const file = event.target.files[0];
      this.t.at(i).patchValue({ fileSource:file })
     
    }
  }

  onUpload(){
    console.log('On upload ')
    console.log('Form Values ',this.t.value)
    let tempFileNames=[];
    this.fileExtensionRowErr=[];
    this.uploadFilesError=false;
    for(let i=0;i<this.t.value.length;i++){
      let errMsg="";
      let index=i+1;
      if(this.t.at(i).value.fileTypeCode === ""
      ||  this.t.at(i).value.fileCodeFilter === ""
){

            continue;
            // validation
          }
       if(this.t.at(i).value.fileNameWithPath.length===0){
          errMsg="Row "+index+"- Missing File";
          this.fileExtensionRowErr.push(errMsg);
          this.uploadFilesError=true;
          console.log(this.uploadFilesError);
          continue;
       }
          console.log('Value ',this.t.at(i).value)
      console.log('Digital Sign ',this.t.at(i).value.digitalSign)
      let digitalSign:boolean = false;
      if(this.t.at(i).value.digitalSign == undefined)
      {
        digitalSign = false;
      }else{
        digitalSign = this.t.at(i).value.digitalSign
      }
      let fileExt=this.getFileExtensionStringPartAtt(this.t.at(i).value.fileTypeCode)+'';
      let currFileExt: string=this.t.at(i).value.fileNameWithPath;
      currFileExt=currFileExt.toLowerCase().substring(currFileExt.lastIndexOf("."));
      let wrgExt=0;
      if(!fileExt.includes(currFileExt) && !fileExt.includes(".all"||".ALL"||"all"||"ALL")){
        errMsg=" Allowed File Extensions are for file type code \""+this.t.at(i).value.fileTypeCode+"\" are "+fileExt;
        wrgExt=1;
      }
      let duplicate=0;
      if(!tempFileNames.includes(this.t.at(i).value.fileNameWithPath)){
        tempFileNames.push(this.t.at(i).value.fileNameWithPath);
      }
      else{
        if(wrgExt){
          errMsg+=","
        }
        errMsg+=" Duplicate File Names in the selection ";
      }
      if(wrgExt||duplicate){
        errMsg="Row "+index+"- Error: "+errMsg;
        this.fileExtensionRowErr.push(errMsg);
        this.uploadFilesError=true;
        continue;
      }

      if(this.uploadFilesError == false && this.fileExtensionRowErr.length ===0){
        
        if(this.accToggleValue == false){

          let fileName: string = this.t.at(i).value.fileNameWithPath;
          fileName = fileName.substring(fileName.lastIndexOf("\\") + 1)
          console.log('File Name ', fileName)
          this.uploadFileInfo.push(
            {
              swbNumber:this.dataService.getUrlParams().partNumber,
              swbRev:this.dataService.getUrlParams().partRevision,
              fileName:fileName,
              fileTypeCode:this.t.at(i).value.fileTypeCode,
              fileDestination:this.t.at(i).value.fileCodeFilter,
              digitalSign:digitalSign,
              replaceAction:true,
              file:this.t.at(i).value.fileSource,
              oldFileName:this.t.at(i).value.fileName
            })

        }else{
          this.uploadFileInfo.push(
            {
              swbNumber:this.dataService.getUrlParams().partNumber,
              swbRev:this.dataService.getUrlParams().partRevision,
              fileName:this.t.at(i).value.fileNameWithPath,
              fileTypeCode:this.t.at(i).value.fileTypeCode,
              fileDestination:this.t.at(i).value.fileCodeFilter,
              digitalSign:digitalSign,
              replaceAction:true,
              oldFileName:this.t.at(i).value.fileName
            })
        }
        

      }
      
   
    
    }

    if(this.uploadFilesError == false && this.fileExtensionRowErr.length ===0){

    if(this.accToggleValue == false){
      // this.dataService.setAgileFileInfo(this.uploadFileInfo);
      console.log('upload file info ',this.uploadFileInfo)
      this.uploadFileInfo.forEach((uploadInfo) => {
        this.dataService.addToAgileFileInfo(uploadInfo);
        let uploadFile:UploadStatusModel;
          uploadFile = {
            fileName : uploadInfo.fileName,
            fileNameWithPath:uploadInfo.fileName,
            fileCacheStatus : this.notStartedStatus,
            acceleratedTransfer:false,
            file:uploadInfo.file,
            avScanStatus : this.notStartedStatus,
            agileUploadStatus : this.notStartedStatus,
            statusPanelEnabled : false,
            fileCacheMessage : {Transfer_Rate:'NA',
            Current_Percent:'NA',
            Transfer_Mode:'NA',
            Time_Remaining:'NA'},
            avsScanMessage : 'Not Started',
            agileUploadMessage : 'Not Started',
            server:0
          }
          this.dataService.addToUploadFiles(uploadFile);
      });
      this.router.navigate(['transferstatus_v2'], { skipLocationChange: true })
    }else{
      console.log('Upload files info ',this.uploadFileInfo);
      this.uploadFileInfo.forEach((value) => 
      {
        this.dataService.pushToAgileFileInfo(value);
      })
      console.log('in Upload files ',this.attachmentInfoDynamicForm.value);
      console.log('Selected Files ',this.selectedFiles);
      console.log('Selected Files string ',this.selectedFilesString);
      if(this.selectedFilesString.length > 0){
        console.log('Initiating FC Connection ')
        console.log('Selected Files String length ',this.selectedFilesString.length)
        for(let i=0;i<this.selectedFilesString.length;i++)
        {
          console.log('index ',i)
          if(this.selectedFilesString[i] == undefined){
            console.log('removing at index ',i)
            this.selectedFilesString.splice(i,1);
          }
        }
      
    
        console.log('Selected Files String after cleanup ',this.selectedFilesString)
        // let result = window.confirm('please make sure that Transfer Agent is started');
        // if(result){
        //   console.log('Entered after checking TA status')
        //   this.initiateFCConnectionAndTransfer();
        // }
        this.initiateFCConnectionAndTransfer();
      }
    }

    
    }
  
  
  }

  initiateFCConnectionAndTransfer()
  {
    this.loadingModalMessage = 'Creating connection...'
    this.openProgressBar()
    this.fcService.getFCUploadConnection().subscribe(
      data => {
        console.log(data)
        console.log('data connection Key',data.connectionKey)
        if(data.connectionKey != undefined){
          this.loadingModalMessage = 'Initating transfer...'
          this.dataService.setFCConnectionKey(data.connectionKey);
          this.initiateFCTransfer(data.connectionKey);
        }
        
      }
    )
  }

  initiateFCTransfer(connectionKey:string)
  {
    
    this.fcService.initiateFCUploadTransfer(connectionKey,this.selectedFilesString).subscribe(
      data =>{
        console.log('Transfer Initiation Data ',data);
        console.log('Transfer Job Id ',data.jobId);

        // // check if the All transfers is Initiated
        // this.fcService.getAllTransferStatus().subscribe((data) => {
        //   console.log('All Transfer Status response ',data)
          
        // })
        if(data.jobId != undefined){
          // this.dialog.closeAll();
          this.closeProgresBar();
          this.dataService.pushToFilesToUpload(this.selectedFilesString);


          this.selectedFilesString.forEach((fileName) => {
            let uploadFile:UploadStatusModel;
          uploadFile = {
          fileName : fileName.substring(fileName.lastIndexOf('/')+1),
          fileNameWithPath:fileName,
          fileCacheStatus : this.notStartedStatus,
          acceleratedTransfer:true,
          avScanStatus : this.notStartedStatus,
          agileUploadStatus : this.notStartedStatus,
          statusPanelEnabled : false,
          fileCacheMessage : {Transfer_Rate:'NA',
          Current_Percent:'NA',
          Transfer_Mode:'NA',
          Time_Remaining:'NA'},
          avsScanMessage : 'Not Started',
          agileUploadMessage : 'Not Started',
          jobid:data.jobId,
          server:0
            }
            this.dataService.addToUploadFiles(uploadFile);
          })

          
          this.router.navigate(['transferstatus_v2'],{skipLocationChange:true})
          
          // this.router.navigate(['file-transfer-status'])
        } 
      }
    )
  }
  getDetails(tempPartAttachments : any){
    console.log('hear hear!')
    this.selectedPartAttachments = this.partAttachments.filter((value) => {if(value.fileSelected)
      {
        return value;
      }})
    return this.selectedPartAttachments
  
  }

  getFormControls(){
    return this.t.controls;
  }
  
 
  public onClick(elementId: string): void { 
    this.viewportScroller.scrollToAnchor(elementId);
}

openProgressBar(){
  this.bodyText ="yyy";
  let btn = document.getElementById("progressbar");
// let btn = document.getElementById("modalbutton");
 btn.click();
 
  
}

closeProgresBar(){
  let clsBtn = document.getElementById("closeModal");
  clsBtn.click();
}




}


